import type { SearchFieldValueListResponseApi } from '@ingenico/api-sdk-device-management-private-v2';

export function mapFromSearchFieldValueListToStringArray(response: SearchFieldValueListResponseApi): string[] {
  return response;
}
